import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '../../src/locales/en/common.json';
import enNavigation from '../../src/locales/en/navigation.json';
import enCourses from '../../src/locales/en/courses.json';
import enForms from '../../src/locales/en/forms.json';
import enHome from '../../src/locales/en/home.json';
import enErrors from '../../src/locales/en/errors.json';

import arCommon from '../../src/locales/ar/common.json';
import arNavigation from '../../src/locales/ar/navigation.json';
import arCourses from '../../src/locales/ar/courses.json';
import arForms from '../../src/locales/ar/forms.json';
import arHome from '../../src/locales/ar/home.json';
import arErrors from '../../src/locales/ar/errors.json';

// Resources object
const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    courses: enCourses,
    forms: enForms,
    home: enHome,
    errors: enErrors,
  },
  ar: {
    common: arCommon,
    navigation: arNavigation,
    courses: arCourses,
    forms: arForms,
    home: arHome,
    errors: arErrors,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    debug: import.meta.env.DEV,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;